module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/exception_frame-c0c579f9ed3cca4846c2302b5c5e469c.svg";